module.exports = __webpack_public_path__ + "static/media/N. Lenore, Willits, CA (2 Buildings)15.66a17366.jpg";